import { TUserType } from "@/types/enum";

/**
 * Returns allowed route patterns per role. Empty array = allow all.
 * Subtype gating removed (admin/user collapse): every user is allowed all routes.
 */
export const getAllowedRoutes = (_userType?: TUserType): string[] => {
  return [];
};
